import { CheckCircle2 } from "lucide-react";
import { InlineCta } from "./CtaBlock";

const TYPE_LABELS = {
  ai_value_label: "AI Value Label",
  sample_report: "Sample report",
  evidence_quality_explainer: "Evidence Quality",
  decision_framework: "Decision framework",
  no_surveillance_trust: "Built on trust",
  before_after_workflow: "Before & after",
  product_screenshot: "Product",
  comparison_table: "Comparison",
  checklist: "Checklist",
  calculator_preview: "Calculator",
};

/** Reusable product-proof block embedded inside resource pages. */
export function ProofBlock({ block }) {
  if (!block) return null;
  return (
    <div
      className="my-8 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm"
      data-testid="resource-proof-block"
    >
      {block.image_url ? (
        <img src={block.image_url} alt={block.headline || block.name} className="w-full object-cover" />
      ) : null}
      <div className="p-6">
        <span className="inline-block rounded-full bg-gold/20 px-2.5 py-0.5 text-xs font-medium text-navy">
          {TYPE_LABELS[block.block_type] || "Proof"}
        </span>
        {block.headline ? (
          <h3 className="mt-3 font-heading text-xl font-semibold text-navy">{block.headline}</h3>
        ) : null}
        {block.body ? <p className="mt-2 text-sm leading-relaxed text-slate-600">{block.body}</p> : null}
        {block.data_points?.length ? (
          <ul className="mt-4 space-y-2">
            {block.data_points.map((d, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-editorial" />
                <span>{d}</span>
              </li>
            ))}
          </ul>
        ) : null}
        {block.cta ? <div className="mt-5"><InlineCta cta={block.cta} /></div> : null}
      </div>
    </div>
  );
}
